import axios from 'axios';

export default axios.create({
  baseURL: 'https://meuagiota.herokuapp.com',
  timeout: 10000,
  headers: {
    'Content-type': 'application/json',
    'mode' : 'cors',
    'Access-Control-Allow-Origin': '*'
  }
});
